import * as React from 'react';
export const IcHarvest = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.25 5.47l-.33-.32A7.29 7.29 0 0013.74 3a.5.5 0 00-.35.85l3.78 3.78a2.59 2.59 0 01.27 3.44 2.509 2.509 0 01-3.73.18l-.51-.49a1.49 1.49 0 00-2.1 0l-2.16 2.18-.35-.35a1.001 1.001 0 00-1.42 0l-2.29 2.29-1 1a3 3 0 000 4.24 3 3 0 004.24 0l1-1 2.29-2.29a.999.999 0 000-1.42l-.35-.35 1.15-1.15a5.512 5.512 0 007.73-1.16 5.63 5.63 0 00-.69-7.28z'
      fill='currentColor'
    />
  </svg>
);
